export const DELIVERY_COST = 10;
export const DISCOUNT = 10;